<template>
  <div>
    <video-player v-bind:options="videoOptions"/>
  </div>
</template>

<script>
import VideoPlayer from '@/components/mixin/VideoPlayer.vue'
import 'video.js/dist/video-js.css'

export default {
  name: 'F04-05',
  components: { VideoPlayer },
  data () {
    return {
      videoOptions: {
        autoplay: false,
        controls: true,
        preload: 'auto',
        poster: 'https://dlrma35v6z0lr.cloudfront.net/output/ikeda.jpg',
        sources: [
          {
            src: 'https://dlrma35v6z0lr.cloudfront.net/output/ikeda_hls.m3u8',
            type: 'application/x-mpegURL'
          }
        ]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
